"use client";

import { collectionSchema } from "../../../lib/types/schema/collection/collectionSchema";
import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyCollection } from "./keyCollection";

export type UseRequestCollectionProps = UseRequestQueryProps & {
  id: number;
  type?: "collection" | "chapter" | "challenge";
};

export const useRequestCollection = ({
  id,
  type = "collection",
  ...props
}: UseRequestCollectionProps) => ({
  ...props,
  query: useRequestQuery({
    queryFnRequestProps: {
      schema: collectionSchema,
      urlBackendPath: `/collections/${id}${type !== "collection" ? `?type=${type}` : ""}`,
    },
    queryKey: keyCollection({ id }),
  }),
});
